import type { MyCorporateBranchAddressLists } from '@/features/Contact/utils/persistMyCorporateBranchAddresses';
import {
    saveMyRegisterContactAddresses,
    type MyRegisterContactAddressSavePayload,
} from '../api/myRegisterApi';
import {
    normalizeRegisterAddressListForSave,
    normalizeRegisterBranchAddressListForSave,
} from './registerAddressSaveNormalize';
import {
    resolveRegisterContactCategoryCd,
    shouldUseRegisterCorporateBranchSave,
} from '../constants/myRegisterPositionCd';

export type MyRegisterAddressDeleteContext = {
    entityCd: string;
    contactCd: string;
    positionCd: string;
    positionName?: string;
    categoryCd?: string;
};

function cloneListsForRegisterSave(
    lists: MyCorporateBranchAddressLists,
    useBranchCodes: boolean,
): Pick<MyRegisterContactAddressSavePayload, 'residential' | 'service' | 'business'> {
    const normalize = useBranchCodes
        ? normalizeRegisterBranchAddressListForSave
        : normalizeRegisterAddressListForSave;
    return {
        residential: normalize(lists.residentialAddressList),
        service: normalize(lists.serviceAddressList),
        business: normalize(lists.businessAddressList),
    };
}

/** MY Register — 역할별 주소 즉시 저장 (삭제 시 빈 목록 포함) */
export async function persistMyRegisterContactAddresses(
    context: MyRegisterAddressDeleteContext,
    lists: MyCorporateBranchAddressLists,
): Promise<void> {
    const entityCd = String(context.entityCd || '').trim();
    const contactCd = String(context.contactCd || '').trim();
    const positionCd = String(context.positionCd || '').trim();
    if (!entityCd || !contactCd || !positionCd) {
        throw new Error('entityCd, contactCd, and positionCd are required');
    }

    const categoryCd = resolveRegisterContactCategoryCd(undefined, context.categoryCd);
    const useBranchCodes = shouldUseRegisterCorporateBranchSave(categoryCd, positionCd);
    const cloned = cloneListsForRegisterSave(lists, useBranchCodes);

    await saveMyRegisterContactAddresses(entityCd, contactCd, {
        positionCd,
        positionName: String(context.positionName || '').trim(),
        categoryCd,
        residential: cloned.residential,
        service: cloned.service,
        business: cloned.business,
    });
}
